import {Button, Stack, styled} from '@mui/material'
import {GridToolbarContainer} from '@mui/x-data-grid'

export const TableContainer = styled(Stack)(() => ({
  gap: '1rem',
}))

export const TopBarContainer = styled(Stack)(() => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
}))

export const ClearButton = styled(Button)(() => ({
  width: '100%',
  marginTop: '2.25rem',
  height: '2rem',
}))

export const SearchContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '2rem',
  height: 35,
}))

export const customInputStyle = {height: 35}

export const StyledButton = styled(Button)(() => ({
  height: '2.2rem',
  fontSize: '0.8rem',
}))

export const StyledToolbarWrapper = styled(GridToolbarContainer)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
}))

export const ToolbarInnerWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '1rem',
}))
